import React, { useEffect, useMemo, useState } from 'react';
import { DateShortInfo, EventShortInfo } from '../../ReportsClasses';
import { useTranslation } from 'react-i18next';
import { Header, Icon, Table } from 'react-frontier';
import { addCommas } from '@arema/components/Util';
import API from '../../ReportsAPI';
import moment from 'moment';

interface DateUses{
	date: number,
	sections: {
		section_id: number,
		section_name: string,
		sort_order: number,
		tickets: number,
		uses: number,
		uses_unique: number,
	}[],
	scanners: {
		scanner_id: number,
		scanner_name: string,
		uses: number,
		uses_unique: number,
	}[]
}

interface DateStatsUsesProps{
	event_id: number,
	event: EventShortInfo,
	date: DateShortInfo,
}

var DateStatsUses = (props: DateStatsUsesProps)=>{
	var { t } = useTranslation();
	var [data, setData] = useState<DateUses>(null);
	var [loadError, setLoadError] = useState<string>(null);

	useEffect(()=>{
		if(!props.date) return;
		API.getDateUses(props.date.date_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setData(res.data);
		}).catch(err=>{
			return setLoadError(t('common.unexpected_code', { code: 'ST-LCL-DTUSS-1' }))
		})
	}, [props.date]);

	var totals = useMemo(()=>{
		if(!data) return { uses: 0, sold: 0 };
		var uses = 0, sold = 0;
		for(var i of data.sections){
			uses += i.uses;
			sold += i.tickets;
		}
		return { uses, sold };
	}, [data]);
	
	if(!props.date) return;
	if(loadError) return <Header text={t('common.error')} subtext={loadError} iconName='face-frown-open' />
	if(!data) return <Header loading text={t('date_uses.loading')} />

	
	return <div className="ar event-date-uses">
		<Table
			striped
			style={{ maxWidth: 500, margin: 'auto', marginTop: 15 }}
			title={t('date_uses.table.title_sections')}
			centeredIndexes={[0, 2, 3, 4]}
			collapsingIndexes={[0, 2, 3, 4]}
			headers={[
				'ID',
				t('date_uses.table.section'),
				t('date_uses.table.sold'),
				t('date_uses.table.uses'),
				t('date_uses.table.percent'),
			]}
			data={[
				...data.sections.map(a=>([
					a.section_id, 
					a.section_name, 
					addCommas(a.tickets, false),
					addCommas(a.uses, false), 
					a.uses>0 ? `${Math.floor((a.uses*100)/a.tickets)}%` : '0%'
				])),
				null,
				[
					null,
					<b>{t('common.total')}</b>,
					<b>{addCommas(totals.sold, false)}</b>,
					<b>{addCommas(totals.uses, false)}</b>,
					<b>{totals.uses>0 ? `${Math.floor((totals.uses*100)/totals.sold)}%` : '0%'}</b>
				]
			]}
		/>
		<Table
			striped
			style={{ maxWidth: 500, margin: 'auto', marginTop: 15 }}
			title={t('date_uses.table.title_scanners')}
			centeredIndexes={[0, 2, 3]}
			collapsingIndexes={[0, 2, 3]}
			headers={[
				'ID',
				t('date_uses.table.scanner'),
				t('date_uses.table.uses'),
			]}
			data={[
				...data.scanners.map(a=>([
					a.scanner_id || <Icon name='minus' color='gray' style={{ margin: 0 }} />,
					a.scanner_name || <span style={{ color: 'gray', fontStyle: 'italic' }}>Otros</span>,
					addCommas(a.uses, false)
				])),
				null,
				[
					'',
					<b>{t('common.total')}</b>,
					<b>{addCommas(totals.uses, false)}</b>
				]
			]}
		/>
		{!!data && (
			<div style={{ textAlign: 'center', color: 'gray', marginTop: 10 }}>{t('dashboard.timestamp')}: {moment.unix(data.date).format('DD/MM/YYYY HH:mm:ss')}</div>
		)}
	</div>
}

export default DateStatsUses;